var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { ApplicationModel, ApplicationsClient, CreateApplicationCommand, GetUserListQuery, RoleTypeEnum, UpdateApplicationCommand, UsersClient } from "@/app/api/battery-portal-api";
import "@/app/component-hooks";
import RouteNames from "@/app/router/routes";
import { LoginState } from "@/app/store/modules/login.state";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import { Alert } from "@/common/utils/alert";
import { Notifier } from "@/common/utils/notifier";
import { Component, Vue } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const applicationClient = new ApplicationsClient(window.apiUrl);
const userClient = new UsersClient(window.apiUrl);
let UserVue = class UserVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.applicationId = 0;
        this.loaded = false;
        this.working = false;
        this.showInfoMessage = true;
        this.newSecret = "";
        // components
        this.msg = new Alert();
        // models
        this.application = new ApplicationModel();
        // arrays
        this.users = [];
    }
    created() {
        this.applicationId = parseInt(this.$route.params.id) || 0;
        this.load();
    }
    ;
    mounted() {
    }
    ;
    removeUsernameSpaces() {
        if (!this.application.applicationName)
            return;
        this.application.applicationName = this.application.applicationName.replace(/\s/g, "");
    }
    ;
    // we have to monitor route changes in order to make Vue react to the change
    beforeRouteUpdate(to, from, next) {
        this.applicationId = parseInt(to.params.id || 0);
        this.application = new ApplicationModel();
        this.get();
        next();
    }
    ;
    load() {
        this.newSecret = "";
        this.get();
        this.getUsers();
    }
    ;
    // get
    get() {
        if (this.isNewApplication) {
            this.loaded = true;
            let application = new ApplicationModel();
            application.init({});
            application.tokenLifetime = 120;
            this.map(application);
            return;
        }
        if (this.working)
            return;
        this.working = true;
        applicationClient
            .get(this.applicationId)
            .then(response => {
            if (!response) {
                this.$router.push({ name: RouteNames.Home });
                return;
            }
            this.loaded = true;
            this.map(response);
            this.setValues({
                name: this.application.applicationName,
                secret: this.application.applicationSecret,
                token: this.application.tokenLifetime
            });
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    getUsers() {
        let query = new GetUserListQuery({
            keywords: "",
            includeDeleted: true,
            roleIds: [RoleTypeEnum.Administrator, RoleTypeEnum.PowerUser, RoleTypeEnum.Integration]
        });
        userClient
            .getListPOST(query)
            .then(response => {
            let users = new Array();
            users = response.map(user => {
                let option = { value: user.userId.toString(), text: `${user.userName} ${(user.whenDeleted ? '(Archived)' : '')}` };
                return option;
            });
            this.users = users;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    map(application) {
        this.application = application;
    }
    ;
    // set
    save() {
        if (this.working)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            this.application.userId = this.userPrincipalId;
            let promise = () => {
                return this.isNewApplication
                    ? applicationClient.add(new CreateApplicationCommand({ requestModel: this.application }))
                    : applicationClient.update(new UpdateApplicationCommand({ requestModel: this.application }));
            };
            promise()
                .then(response => {
                this.working = false;
                if (this.isNewApplication && response) {
                    this.applicationId = response.applicationId;
                    this.newSecret = response.applicationSecret;
                }
                Notifier.onOk();
                this.get();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have entered all details correctly.");
        });
        handleSubmitAction();
    }
    ;
    archive() {
        if (this.working || this.isNewApplication)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this application?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            applicationClient
                .delete(this.application.applicationId)
                .then(() => {
                this.application.whenDeleted = new Date();
                Notifier.onOk(`Application # ${this.application.applicationId} has been successfully archived.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore() {
        if (this.working || this.isNewApplication)
            return;
        applicationClient
            .restore(this.application.applicationId)
            .then(() => {
            this.application.whenDeleted = undefined;
            Notifier.onOk(`Application # ${this.application.applicationId} has been successfully restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    changeSecret() {
        if (this.working || this.isNewApplication)
            return;
        this.$confirmModal.show("Are you sure that you change this application's secret?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            applicationClient
                .rotateKey(this.application.applicationId)
                .then(secret => {
                this.application.applicationSecret = secret;
                Notifier.onOk();
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    goBack() {
        this.$router.back();
    }
    ;
    // computed
    get pageTitle() {
        return this.isNewApplication ? "New Application" : this.applicationTitle;
    }
    ;
    get applicationTitle() {
        if (!this.application)
            return "";
        return TextHelper.getRecordTitle(this.application.applicationName || "", this.isApplicationArchived);
    }
    ;
    get isNewApplication() {
        return !this.applicationId;
    }
    ;
    get isApplicationArchived() {
        if (!this.application)
            return false;
        return this.application.whenDeleted != null;
    }
    ;
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    ;
    get appHasLoggedIn() {
        return this.application.whenLastActive ? true : false;
    }
    ;
    get whenLastActiveString() {
        return DateHelper.convertToFriendlyMomentTimeString(this.application.whenLastActive || null);
    }
    ;
    get userPrincipalId() {
        return this.application.userId;
    }
    ;
    get userPrincipal() {
        let user = this.users.filter(item => {
            return (item.value == this.application.userId);
        })[0] || null;
        return user;
    }
    ;
    set userPrincipal(item) {
        var _a;
        this.application.userId = (_a = item === null || item === void 0 ? void 0 : item.value) !== null && _a !== void 0 ? _a : null;
    }
    ;
    get showNewAPISecret() {
        return this.newSecret != "";
    }
    set showNewAPISecret(value) {
        if (!value)
            this.newSecret = "";
    }
    copyToClipboard() {
        navigator.clipboard.writeText(this.newSecret);
        Notifier.onOk("Copied");
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], UserVue.prototype, "loginState", void 0);
UserVue = __decorate([
    Component({
        name: "ApplicationVue",
        setup() {
            const { errors, handleSubmit, defineInputBinds, setValues } = useForm({
                validationSchema: yup.object({
                    name: yup.string().trim().required(),
                    newApplication: yup.boolean(),
                    token: yup.number().required(),
                }),
            });
            const nameVal = defineInputBinds('name');
            const tokenVal = defineInputBinds('token');
            return {
                errors,
                handleSubmit,
                setValues,
                nameVal,
                tokenVal,
            };
        }
    })
], UserVue);
export default UserVue;
